import { IFracFleetAvailability } from '../../interfaces/ifrac-fleet-availability';
import { FracFleet } from '../frac-fleet';

export class FracFleetAvailabilityBase {
  FracFleetAvailabilityId: number;
  FracFleetId: number;
  StartDate: Date;
  EndDate: Date;
  IsJointVenture: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FracFleet?: FracFleet;

  constructor(item?: IFracFleetAvailability) {
    if (item) {

      this.FracFleetAvailabilityId = item.FracFleetAvailabilityId;
      this.FracFleetId = item.FracFleetId;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.EndDate = item.EndDate ? new Date(item.EndDate) : null;
      this.IsJointVenture = item.IsJointVenture;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FracFleet = new FracFleet(item.FracFleet);
    }
  }
}